module.exports = __webpack_public_path__ + "img/verification.9fbdc485.png";